import { withAuthenticationRequired } from '@auth0/auth0-react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import AllShipCompanies from '@components/pages/admin/ShipCompanies/AllShipCompanies.tsx';

const AdminShipCompanies = () => {
  return (
    <AdminLayout title={'Shipping Companies'}>
      <AllShipCompanies />
    </AdminLayout>
  );
};

export default withAuthenticationRequired(AdminShipCompanies);
